/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AcceptedBidDto } from '../models/accepted-bid-dto';
import { AcceptedBidDataDto } from '../models/accepted-bid-data-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedAcceptedBidService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createAcceptedBid
   */
  static readonly CreateAcceptedBidPath = '/api/accepted-bids';

  /**
   * Creates a new accepted-bid.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAcceptedBid()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAcceptedBid$Response(params: {
    'X-API-Version'?: string;
    body: AcceptedBidDataDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<AcceptedBidDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedAcceptedBidService.CreateAcceptedBidPath, 'post');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AcceptedBidDto>;
      })
    );
  }

  /**
   * Creates a new accepted-bid.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAcceptedBid$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAcceptedBid(params: {
    'X-API-Version'?: string;
    body: AcceptedBidDataDto
  },
  context?: HttpContext

): Observable<AcceptedBidDto> {

    return this.createAcceptedBid$Response(params,context).pipe(
      map((r: StrictHttpResponse<AcceptedBidDto>) => r.body as AcceptedBidDto)
    );
  }

  /**
   * Path part for operation deleteAcceptedBid
   */
  static readonly DeleteAcceptedBidPath = '/api/accepted-bids/{id}';

  /**
   * Withdraws an existing accepted-bid.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAcceptedBid()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAcceptedBid$Response(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedAcceptedBidService.DeleteAcceptedBidPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Withdraws an existing accepted-bid.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAcceptedBid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAcceptedBid(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteAcceptedBid$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
